import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Instagram, Facebook, Twitter } from "lucide-react";

const navItems = [
  { href: "#features", label: "Features" },
  { href: "#work", label: "Work" },
  { href: "#values", label: "Values" },
  { href: "#faq", label: "FAQ" },
  { href: "#contact", label: "Contact" },
];

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? "bg-levi-bg/80 backdrop-blur-xl border-b border-levi-border"
          : "bg-transparent"
      }`}
    >
      <div className="container-xl flex items-center justify-between py-4">
        <a href="/" className="flex items-center space-x-3 group">
          <div className="relative">
            <div className="absolute -inset-1 bg-levi-primary/40 blur-md opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            <img
              src="/assets/levi-logo.jpg"
              alt="Phuc Pham"
              className="relative h-11 w-11 rounded-full object-cover ring-2 ring-levi-primary/80"
            />
          </div>
          <div className="flex flex-col leading-none">
            <span className="font-display text-2xl tracking-widest text-levi-text whitespace-nowrap">
              Phuc Pham
            </span>
            <span className="font-mono text-[10px] tracking-ultra uppercase text-levi-muted">
              Studio
            </span>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="relative text-sm uppercase tracking-widest text-levi-muted hover:text-levi-text transition-colors duration-300 group"
            >
              {item.label}
              <span className="absolute -bottom-2 left-0 h-px w-0 bg-levi-primary transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
          <div className="h-6 w-px bg-levi-border" />
          <div className="flex items-center gap-4">
            <a href="#" aria-label="Instagram" className="text-levi-muted hover:text-levi-primary transition-colors">
              <Instagram size={18} />
            </a>
            <a href="#" aria-label="Facebook" className="text-levi-muted hover:text-levi-primary transition-colors">
              <Facebook size={18} />
            </a>
            <a href="#" aria-label="Twitter" className="text-levi-muted hover:text-levi-primary transition-colors">
              <Twitter size={18} />
            </a>
          </div>
        </nav>

        <button
          className="md:hidden text-levi-text p-2 cursor-pointer"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="md:hidden overflow-hidden bg-levi-bg/95 backdrop-blur-xl border-t border-levi-border"
          >
            <div className="container-xl py-6 flex flex-col gap-5">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={() => setIsMenuOpen(false)}
                  className="text-lg uppercase tracking-widest text-levi-muted hover:text-levi-primary transition-colors"
                >
                  {item.label}
                </a>
              ))}
              <div className="flex gap-5 pt-4 border-t border-levi-border">
                <a href="#" aria-label="Instagram" className="text-levi-muted hover:text-levi-primary"><Instagram size={20} /></a>
                <a href="#" aria-label="Facebook" className="text-levi-muted hover:text-levi-primary"><Facebook size={20} /></a>
                <a href="#" aria-label="Twitter" className="text-levi-muted hover:text-levi-primary"><Twitter size={20} /></a>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;
